import { combineEpics } from 'redux-observable';
import { loadDulplicateDataSourcesEpicReducer } from '../ducks/DataSourceDuplicate.ducks';
export default combineEpics(loadDulplicateDataSourcesEpicReducer.epic);

//# sourceMappingURL=DataSourceDuplicateEpic.js.map
